/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanProgramEntryPointEntrypointProps } from './PlanProgramEntryPoint.entrypoint.types.tsx';

type PlanProgramEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanProgramEntryPointEntrypointProps,
	{}
>;

export const planProgramEntryPoint: EntryPoint<PlanProgramEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanProgramEntryPointComponent>(
			/* webpackChunkName: "async-plan-program-entrypoint" */ './AdvancedRoadmapsPlanProgramPlanProgram.tsx',
		),
		getPreloadProps: () => ({}),
	});
